// extracted by mini-css-extract-plugin
module.exports = {"HorizontalRow":"styles_HorizontalRow__23C1s"};